<template>
  <el-dialog  :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" @close="resetForm">
    <template #title>
      <h4>{{$t('区间声音设置')}}</h4>
    </template>

    <el-form label-width="auto" ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('名称')" prop="name">
        <el-input :placeholder="$t('名称')" v-model="formData.name" />
      </el-form-item>
      <el-form-item :label="$t('声音设置')" prop="soundSet">
        <el-upload
            ref="upload"
            :file-list="fileList"
            :action="$api.file.upload"
            accept=".mp3,.wma,.wav"
            :on-success="handleUploadSuccess"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :limit="1">
          <el-button size="mini" type="primary" icon="el-icon-upload2">{{$t('上传文件')}}</el-button>
          <div slot="tip" class="el-upload__tip">{{$t('格式支持')}} mp3、wma、wav</div>
        </el-upload>

      </el-form-item>
      <el-form-item :label="$t('协议代码')" prop="protocolCode">
        <div class="flex" style="column-gap: 10px">
          <el-input :placeholder="$t('协议代码')" v-model="formData.protocolCode" />
          <el-button type="primary" size="mini">{{$t('保存')}}</el-button>
        </div>
      </el-form-item>
      <el-form-item :label="$t('备注')">
        <el-input :placeholder="$t('备注')" v-model="formData.remark" type="textarea" :rows="5" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      <el-button @click="resetForm">{{$t('重置')}}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {resetEmpty} from "@/utils/common";

export default {
  name: "PartSoundForm",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        name: "",
        protocolCode: "",
        soundSet: "", // 文件
        remark: "",
        fileName: "",
      },

      rules: {
        name: {required: true, message: this.$t('请输入名称'), trigger: 'blur'},
        protocolCode: {required: true, message: this.$t('请输入协议代码'), trigger: 'blur'},
        soundSet: {required: true, message: this.$t('请上传文件'), trigger: 'change'},
      },
      fileList: []
    }
  },
  methods: {
    // 上传成功
    handleUploadSuccess(res, file) {
      if (res.status !== 200) {
        this.$message.error(res?.desc || this.$t('上传失败'));
        return;
      }
      this.formData.fileName = file.name;
      this.formData.soundSet = res.data.code;
      this.$refs.form.clearValidate("soundSet");
    },

    handleExceed() {
      this.$message.warning(this.$t('只能上传1个文件'));
    },

    handleRemove() {
      this.formData.soundSet = "";
      this.formData.fileName = "";
    },

    // 确认
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if(!valid) return;
        this.$emit('confirm', this.formData)
      })
    },

    resetForm() {
      this.$refs.upload.clearFiles();
      this.fileList = [];
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    }
  },
  watch: {
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }

        const {fileName, soundSet} = this.formData;
        if(this.soundSet) {
          this.fileList = [{name: fileName, url: this.$api.file.downloadImg + soundSet}];
        }
      }
    }
  },
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 500px;
  border-radius: 10px;
}
</style>
